import { getFirestore, doc, collection, query, where, addDoc, getDoc, getDocs, updateDoc, setDoc, onSnapshot, deleteDoc, documentId } from "firebase/firestore"
import { offersFromData, offersToData } from "@/assets/functions/offerManager.js"
import { removeCodesFromProfiles } from "@/assets/functions/assetCleanup.js"
let db = getFirestore()

let collectionName = "codes"

function docToInstance(document) {
	let data = document.data()
	if (!data) return null

	const offers = offersFromData(data)

	return new Code(
		document.id,
		data.name,
		data.description,
		data.end,
		data.amount,
		offers,
		data.archived === true
	)
}

class Code {
	constructor(id, name, description, end, amount, offers = [], archived = false) {
		this.id = id
		this.name = name
		this.description = description
		this.end = end
		this.amount = amount
		this.offers = (Array.isArray(offers) && offers.length) ? offers : offersFromData({})
		this.archived = archived === true
	}

	static initOne(name = "") {
		let id = Code.createId(name)
		const newCode = new Code(id, name, "", 0, 1, offersFromData({}), false)
		return newCode
	}

	static createId(name) {
		let id = name
			.replace(/[^a-zA-Z0-9 ]/g, "")
			.replace(/ /g, "-")
			.toLowerCase()
			.replace(/-+/g, "-")
			.replace(/^-|-$/g, "")
		return id
	}

	static async getAll() {
		const documents = await getDocs(collection(db, collectionName))
		return documents.docs.map(docToInstance)
	}

	static async getById(id) {
		const document = await getDoc(doc(db, collectionName, id))
		return docToInstance(document)
	}

	static async getByName(name) {
		const q = query(collection(db, collectionName), where("name", "==", name))
		const documents = await getDocs(q)
		return documents.docs.map(docToInstance)
	}

	static async listenAll(callback) {
		return onSnapshot(collection(db, collectionName), (snapshot) => {
			const list = []
			snapshot.forEach((doc) => {
				list.push(docToInstance(doc))
			})
			callback(list)
		})
	}

	static async listenById(id, callback) {
		return onSnapshot(doc(db, collectionName, id), (snapshot) => {
			callback(docToInstance(snapshot))
		})
	}

	static async listenByName(name, callback) {
		const q = query(collection(db, collectionName), where("name", "==", name))
		return onSnapshot(q, (snapshot) => {
			const list = []
			snapshot.forEach((doc) => {
				list.push(docToInstance(doc))
			})
			callback(list)
		})
	}

	async save() {
		const offers = offersToData(this.offers)
		const new_doc = {
			name: this.name,
			description: this.description,
			end: this.end,
			amount: this.amount,
			offers: offers,
			archived: this.archived === true,
		}

		if (this.id) {
			await setDoc(doc(db, collectionName, this.id), new_doc)
		} else {
			this.id = Code.createId(this.name)
			await setDoc(doc(db, collectionName, this.id), new_doc)
		}
		return true
	}

	async delete() {
		if (this.id) {
			// Cascade : retire le code de l'historique et des réductions actives des profils.
			await removeCodesFromProfiles([this.id])
			await deleteDoc(doc(db, collectionName, this.id))
		}
		return true
	}
}

export default Code
